const initialState = {
	"listado": [],
	"cirugias": [],
	"condiciones_generales": [],
	"retenciones": [],
	"historicoPagos": [],

	"lista_blanca_state": []
};

export function tramitesRdc(state = initialState, action) {
	switch (action.type) {
	case "TRAMITES_LLENAR":
		return {...state,
			"listado": action.listado
		};
	case "TRAMITES_LLENAR_CIRUGIAS":
		return {...state,
			"cirugias": action.cirugias
		};
	case "TRAMITES_LLENAR_CONDICIONES_GENERALES":
		return {...state,
			"condiciones_generales": action.condiciones_generales
		};
	case "TRAMITES_LISTA_BLANCA":
		return {...state,
			"lista_blanca_state": action.lista_blanca_state
		};
	case "HISTORICO_PAGOS_LLENAR":
		return {...state,
			"historicoPagos": action.historicoPagos
		};
	case "RETENCIONES_LIMPIAR":
		return {...state,
			"retenciones": []
		};
	case "RETENCIONES_LLENAR": 
		return {...state,
			"retenciones": action.retenciones
		};
	case "TRAMITES_SET_EVENT":
		return {...state,
			"evento": action.evento
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/mis-tramites/reducer.js